import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Input, Col, Row } from 'reactstrap';
import configService from '../../services/configService';
import DropDownShow from './DropDownShow';

import styles from './Filter.module.css';

const Filter = (props) => {
    const [allFileTypes, setAllFileTypes] = useState([]);

    useEffect(() => {
        configService.fileTypes()
            .then(data => setAllFileTypes(data));
    }, []);

    const col = props.hideFileType ? { xs: 6, lg: 4 } : { xs: 4, lg: 3 };
    
    return (
        <Row>
            <Col>
                <Row className="justify-content-between">
                    <Col xs={col.xs} lg={col.lg}>
                        <FormGroup className="mb-0">
                            <DropDownShow withAwardsDBConnection={props.withAwardsDBConnection} shows={props.shows} show={props.show} onShowChanged={props.onShowChanged}  />
                        </FormGroup>
                    </Col>
                    {   props.hideFileType ? null :
                        <Col xs={col.xs} lg={col.lg}>
                            <FormGroup className="mb-0">
                                <Input type="select" name="fileType" value={props.fileType} onChange={event => props.onFileTypeChanged(event.target.value)}>
                                    <option value="">File type</option>
                                    {
                                        (allFileTypes || props.fileTypes || []).map(fileType => <option key={fileType.value} value={fileType.value}>{fileType.text}</option>)
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                    }
                    <Col xs={col.xs} lg={col.lg}>
                        <FormGroup className="mb-0">
                            <Input type="text" placeholder="Search..." name="search" defaultValue={props.search} onChange={event => props.onSearchChanged(event.target.value)} />
                        </FormGroup>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default Filter;